package com.vamvisions.main.core.presentation.navigation

import com.vamvisions.main.core.domain.preferences.Language

/** A page of the website, identified by its URL path. */
sealed interface Route {
    data object Home : Route
    data object Portfolio : Route
    data object Projects : Route
    data object Contact : Route
    data class ProjectDocument(val slug: String, val language: Language) : Route

    /** A path that matches no page. [path] is kept so the address bar is left unchanged. */
    data class NotFound(val path: String) : Route
}
